import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';

interface IDocsComponentImport {
    importReplaceOneFile: (config: {
        padType: string,
        fileId: string,
    }) => void;
}

export async function loadDocsComponentImport() {
    return await ArkLoader.extensionService.getExtension<IDocsComponentImport>(componentConfig.name);
}

